module.exports = __webpack_public_path__ + "img/SDAgenda.4c13d021.png";